import React from "react";
import { FILESTREAM_PURL } from "Constants";
import { RiskAnalysisCard } from "Modules/riskAnalysisCard";
import { PortalFile } from "Types";
import styles from "./fileRow.module.scss";

type FileDetailsProps = {
  rowIndex: number;
  file: PortalFile;
};

const FileDetails = ({
  rowIndex,
  file,
}: FileDetailsProps): React.JSX.Element => {
  return (
    <div className={styles["file-details"]}>
      {file.latest_report_summary && (
        <RiskAnalysisCard
          id={`current-${rowIndex}`}
          file={{
            type: "FILESTREAM",
            displayName: file.file_name,
            fileName: file.file_name,
            id: file.id,
            imported_from: file.imported_from,
            upload_date: file.created,
            software_info: file.software_info,
            latest_report_summary: file.latest_report_summary,
          }}
          reportDetails={{
            isRepro: undefined,
            packageName: FILESTREAM_PURL.packageName,
            projectName: FILESTREAM_PURL.projectName,
            version: file.id,
          }}
        />
      )}
    </div>
  );
};

export default FileDetails;
